import { Directive, HostListener, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appOnlyNumbers]'
})
export class OnlyNumbersDirective {

  constructor(@Optional() private formControl: NgControl) { }
  @HostListener('input', ['$event']) onInput(event: any) {
    if (this.formControl) {
      this.formControl.control!.patchValue(this.formControl.control!.value.replaceAll(/[^0-9]/g, ''));
    }
  }
}
